import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getImageUrl } from 'constants/constants';
import { getProductById } from 'helpers/backend_helper';
import { Loader2 } from 'lucide-react';

const CustomerProductDetail = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (productId) loadProduct();
  }, [productId]);

  const loadProduct = async () => {
    try {
      setIsLoading(true);
      const response = await getProductById(productId!);
      if (response.success && response.data?.[0]) {
        setProduct(response.data[0]);
      }
    } catch (error) {
      console.error('Error loading product', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="size-12 animate-spin text-custom-500" />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4">
        <p className="text-slate-500">Product not found.</p>
        <Link to="/customer/products" className="text-custom-500 hover:underline">
          Back to products
        </Link>
      </div>
    );
  }

  const variants = product?.productsProductvariants || [];
  const firstVariant = variants[0];
  const imageUrl = product?.imageUrl || firstVariant?.imageUrl || product?.productsProductimages?.[0]?.url;

  return (
    <div className="mx-auto max-w-5xl">
      <Link to="/customer/products" className="mb-4 inline-block text-sm text-custom-500 hover:underline">
        ← Back to products
      </Link>
      <div className="grid gap-8 md:grid-cols-2">
        <div className="aspect-square overflow-hidden rounded-xl bg-slate-100 dark:bg-zink-600">
          {imageUrl ? (
            <img
              src={getImageUrl(imageUrl, 'productThumbnail')}
              alt={product.name}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-slate-400">
              <span className="text-6xl">{product.name?.charAt(0) || '?'}</span>
            </div>
          )}
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-800 dark:text-zink-100">
            {product.name}
          </h1>
          <p className="mt-2 text-slate-600 dark:text-zink-300">
            {product.description || 'No description available.'}
          </p>
          <p className="mt-4 text-2xl font-semibold text-custom-500">
            ₹{firstVariant?.unitPrice || product.unitPrice || '—'}
          </p>
          <p className="mt-2 text-sm text-slate-500">
            SKU: {product.sku || '—'}
          </p>
          <Link
            to="/customer/cart"
            className="mt-6 inline-block rounded-lg bg-custom-500 px-6 py-3 font-medium text-white hover:bg-custom-600"
          >
            Add to Cart
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CustomerProductDetail;
